/**
 * Composable for managing Product Listing Page (PLP) function bar refinement visibility.
 *
 * @returns {Object} An object containing computed properties for refinement visibility.
 * @property {ComputedRef<boolean>} isSizeRefinementVisible - Indicates if size refinement options are available.
 * @property {ComputedRef<boolean>} isColorRefinementVisible - Indicates if color refinement options are available.
 *
 * @example
 * const { isSizeRefinementVisible, isColorRefinementVisible } = usePlpFunctionBar()
 *
 * @remarks
 * This composable uses the Algolia Instant Search (AIS) widget to determine refinement visibility.
 * Refinements are considered visible if they have more than one item.
 */
export const usePlpFunctionBar = () => {
  const refinementListState = useAisWidget('refinementList')

  const isSizeRefinementVisible = computed(
    () =>
      refinementListState?.state?.value?.['size.sizeCode']?.items?.length > 1
  )
  const isColorRefinementVisible = computed(
    () => refinementListState?.state?.value?.MacroColorDesc?.items?.length > 1
  )

  return {
    isSizeRefinementVisible,
    isColorRefinementVisible,
  }
}
